
// map
export { default as OpenLayersContext } from './map/OpenLayersContext';
export { OL_VERSION as olVersion } from './map/OpenLayersContext';
